import {
  RESET_STAFF_DETAIL,
  STAFF_ADD_FAILURE,
  STAFF_ADD_REQUEST,
  STAFF_ADD_SUCCESS,
  STAFF_DELETE_FAILURE,
  STAFF_DELETE_REQUEST,
  STAFF_DELETE_SUCCESS,
  STAFF_FETCH_ALL_FAILURE,
  STAFF_FETCH_ALL_REQUEST,
  STAFF_FETCH_ALL_SUCCESS,
  STAFF_UPDATE_FAILURE,
  STAFF_UPDATE_REQUEST,
  STAFF_UPDATE_SUCCESS,
  STAFF_VIEW_ALL_FAILURE,
  STAFF_VIEW_ALL_REQUEST,
  STAFF_VIEW_ALL_SUCCESS,
  STAFF_VIEW_FAILURE,
  STAFF_VIEW_REQUEST,
  STAFF_VIEW_SUCCESS,
} from './StaffType';

export const staffFetchAllRequest = () => {
  return {
    type: STAFF_FETCH_ALL_REQUEST,
  };
};
export const staffFetchAllSuccess = (payload) => {
  return {
    type: STAFF_FETCH_ALL_SUCCESS,
    payload,
  };
};
export const staffFetchAllFailure = (payload) => {
  return {
    type: STAFF_FETCH_ALL_FAILURE,

    payload,
  };
};

export const StaffViewRequest = (payload) => {
  return {
    type: STAFF_VIEW_REQUEST,
    payload,
  };
};
export const StaffViewSuccess = (payload) => {
  return {
    type: STAFF_VIEW_SUCCESS,
    payload,
  };
};
export const StaffViewFailure = (payload) => {
  return {
    type: STAFF_VIEW_FAILURE,
    payload,
  };
};
export const staffAddRequest = (payload) => {
  return {
    type: STAFF_ADD_REQUEST,
    payload,
  };
};
export const staffAddSuccess = (payload) => {
  return {
    type: STAFF_ADD_SUCCESS,
    payload,
  };
};
export const staffAddFailure = (payload) => {
  return {
    type: STAFF_ADD_FAILURE,
    payload,
  };
};
export const staffUpdateRequest = (payload) => {
  return {
    type: STAFF_UPDATE_REQUEST,
    payload,
  };
};
export const staffUpdateSuccess = (payload) => {
  return {
    type: STAFF_UPDATE_SUCCESS,
    payload,
  };
};
export const staffUpdateFailure = (payload) => {
  return {
    type: STAFF_UPDATE_FAILURE,
    payload,
  };
};
export const staffViewAllRequest = (payload) => {
  return {
    type: STAFF_VIEW_ALL_REQUEST,
    payload,
  };
};
export const staffViewAllSuccess = (payload) => {
  return {
    type: STAFF_VIEW_ALL_SUCCESS,
    payload,
  };
};
export const staffViewAllFailure = (payload) => {
  return {
    type: STAFF_VIEW_ALL_FAILURE,
    payload,
  };
};
export const staffDeleteRequest = (payload) => {
  return {
    type: STAFF_DELETE_REQUEST,
    payload,
  };
};
export const staffDeleteSuccess = (payload) => {
  return {
    type: STAFF_DELETE_SUCCESS,
    payload,
  };
};
export const staffDeleteFailure = (payload) => {
  return {
    type: STAFF_DELETE_FAILURE,
    payload,
  };
};
export const resetStaffDetail = () => {
  return {
    type: RESET_STAFF_DETAIL,
  };
};
